import { yupResolver } from "@hookform/resolvers";
import {
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { InferType } from "yup";
import CustomButton from "../../../../../../components/Button/CustomButton";
import { wompiKeySchema } from "../../../../../../services/formValidation";
import { useUpdateWompiPublicKey } from "../../../../../../utils/react-query/querySupplier/queries";

const WompiKey = ({ initialPublicKey }: { initialPublicKey: string }) => {
  const { handleSubmit, control, errors } = useForm<
    InferType<typeof wompiKeySchema>
  >({
    resolver: yupResolver(wompiKeySchema),
    defaultValues: {
      publicKey: initialPublicKey || "",
    },
  });
  const { mutateAsync: updateWompiKey, isLoading: isUpdatingWompiKey } =
    useUpdateWompiPublicKey();

  const [showKey, setShowKey] = useState(false);

  const onSubmit = async (data: InferType<typeof wompiKeySchema>) => {
    if (!data.publicKey) return;
    await updateWompiKey({ wompiKey: data.publicKey });
  };

  return (
    <Paper className="paper-container">
      <div className="wompikey-content">
        <div className="wompikey-header">
          <h1>Llave Pública de Wompi</h1>
          <p>
            La llave pública de Wompi es necesaria para procesar pagos a través
            de tu tienda. Asegúrate de ingresar la llave correcta para que todas
            las transacciones y pagos generados se realicen a nombre de la
            cuenta con la cual se creó.
          </p>
        </div>
        <hr className="hr-separator" />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        >
          <Controller
            name="publicKey"
            control={control}
            render={({ onChange, onBlur, value, name, ref }) => (
              <TextField
                type={showKey ? "text" : "password"}
                label="Llave Pública"
                variant="outlined"
                fullWidth
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                inputRef={ref}
                error={!!errors.publicKey}
                helperText={errors.publicKey ? errors.publicKey.message : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle key visibility"
                        onClick={() => setShowKey(!showKey)}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {showKey ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <CustomButton
            className="wompikey-button-submit"
            type="submit"
            color="secondary"
            shape="little-rounded"
            size="medium"
            isLoading={isUpdatingWompiKey}
          >
            Guardar Llave
          </CustomButton>
        </form>
      </div>
      <div className="wompi-config">
        <a href="https://login.wompi.co/" target="_blank" rel="noreferrer">
          <p>Gestionar Pagos por Wompi</p>
        </a>
      </div>
    </Paper>
  );
};

export default WompiKey;
